import { api } from './client';

const exportFile = (params, path, filename) => api.download(path, {
    method: 'post',
    data: params,
    filename,
});

export default exportFile;
